import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentDate, getOnePreviousDate } from "../../Utilitie";
import Loading from "../../Extra/Loading";

const CIData = ({
  setApiData,
  setApiData1,
  setApiData2,
  setApiData3,
  setApiData4,
  setApiData5,
  setApiData6,
  date,
  setDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;

  const fetchApi = async (url, setState) => {
    setLoading(true);
    try {
      const response = await axios.get(url);

      if (response.data.status === "ok") {
        setState(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApi(
      `${urlPrefix}interchange_comparison_TO_Ho?date=${date}`,
      setApiData,
    );
    fetchApi(`${urlCrisPrefix}get_wcrpt057_data?date=${date}`, setApiData1);
    fetchApi(`${urlCrisPrefix}get_wc017_data?date=${date}`, setApiData2);
    fetchApi(`${urlCrisPrefix}get_t_rb826_data?date=${date}`, setApiData3);
    fetchApi(`${urlCrisPrefix}get_t_wcrprt007_data?date=${date}`, setApiData4);
    fetchApi(`${urlCrisPrefix}get_wc547_data?date=${date}`, setApiData5);
    fetchApi(`${urlCrisPrefix}get_wc420_data?date=${date}`, setApiData6);
  }, [date]);

  return (
    <div>
      {" "}
      <div>
        <div className="d-flex pb-2  justify-content-center ">
          {loading && <Loading />}
        </div>
      </div>
    </div>
  );
};
export default CIData;
